import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.19.0_@azure+identity@4.11.1_@parcel+watcher@2.5.1_@types+node@20.5.1_@vue+compil_ef1adb280084d0d666139f3f0ec454ca/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.19.0_@azure+identity@4.11.1_@parcel+watcher@2.5.1_@types+node@20.5.1_@vue+compil_ef1adb280084d0d666139f3f0ec454ca/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}